import './child-bio-details.scss';

import { useTranslation } from 'react-i18next';

import { ChildDetails } from '@sola/schema/dotcom/children/child.js';

import { getAge } from '../../utils/child-bio';

/**
 * Child bio info section
 */
export const ChildBioInfo = ({
  details,
  countryKey,
  note,
}: {
  details: ChildDetails;
  countryKey: string;
  note?: string;
}) => {
  const { t } = useTranslation(['bio']);
  const age = getAge(details.ageInYearsAndMonths);

  return (
    <div>
      <p>
        <span className="label-xl label-potent ChildBioDetails__label">
          {t('bio:age')}
        </span>
        {age}
      </p>
      <p>
        <span className="label-xl label-potent ChildBioDetails__label">
          {t('bio:birthday')}
        </span>
        {new Date(details.birthDate || '').toLocaleDateString(
          t('bio:localeFormat'),
          { year: 'numeric', month: 'long', day: 'numeric' },
        )}
        {details.isBirthDateEstimated && t('bio:estimatedBirthday')}
      </p>
      <p>
        <span className="label-xl label-potent ChildBioDetails__label">
          {t('bio:gender')}
        </span>
        {t('bio:genders', { context: details.gender.toString() })}
      </p>
      <p>
        <span className="label-xl label-potent ChildBioDetails__label">
          {t('bio:location')}
        </span>
        {t(countryKey as unknown as TemplateStringsArray)}
      </p>
      <p>
        <span className="label-xl label-potent ChildBioDetails__label">
          {t('bio:localId')}
        </span>
        {details.localId}
      </p>
      {note && (
        <p>
          <span className="label-xl label-potent ChildBioDetails__label">
            {t('bio:note')}
          </span>
          {note}
        </p>
      )}
    </div>
  );
};
